<template>
    <div class="card" id="formEvents">
        <div class="card-header">
            <h3 class="card-title" v-if="!updateData">New Event</h3>
            <h3 class="card-title" v-else>Update Event <span class="badge badge-info">Id # {{ f.event_id }}</span></h3>
        </div>
        <div class="card-body">
            <form @submit.prevent="saveEvent()" class="form-lead">
                <div class="row form-group">
                    <div class="col-8">
                        <label class="label-input">Event Title *</label>
                        <input type="text" v-model="f.event_name" class="form-control" placeholder="My Event" required>
                    </div>
                    <div class="col-4">
                        <label class="label-input">Event Date</label>
                        <date-picker v-model="dateSelected" format="YYYY-MM-DD HH:mm a" placeholder="YYYY-MM-DD HH:mm"
                            type="datetime" :input-attr="{ 'data-value': dateSelected }" :show-time-panel="showTimePanel"
                            :minute-step="5" input-class="form-control input-event-date" @open="dateOpen()" @close="closeDatePicker()"
                            @input="changeDate" :clearable="false" :show-second="false" :open.sync="openCal"
                            :use12h="true" :use-utc="true">
                            <template v-slot:header="{ emit }" class="header-date-picker">
                                <button class="mx-btn mx-btn-text btn-today" @click="emit(new Date())">Today</button>
                            </template>
                            <template v-slot:footer>
                                <button class="mx-btn mx-btn-text" @click="closeDatePicker" >
                                    Ok
                                </button>
                                <button type="button" class="mx-btn mx-btn-text" @click="toggleTimePanel"
                                    v-if="!showTimePanel">
                                    Hours
                                </button>
                                <button type="button" class="mx-btn mx-btn-text" @click="toggleTimePanel" v-else>
                                    Date
                                </button>
                                <button type="button" class="mx-btn mx-btn-text" @click="closeDatePicker">
                                    Close
                                </button>
                            </template>
                        </date-picker>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-4">
                        <label class="label-input">Event Type *</label>
                        <select v-model="f.event_type" class="form-control" required>
                            <option value="" disabled>Select Event type</option>
                            <option v-for="type in listEventTypes" :key="type.id" :value="type.id">{{ type.name }}</option>
                        </select>
                    </div>
                    <div class="col-8">
                        <label :class="['label-input', f.event_type!=106 ? 'disabled' : '']">Specify Event Type *</label>
                        <input type="text" v-model="f.event_type_custom" :class="['form-control', (f.event_type==106) ? 'border border-info' : '']" placeholder="Other type of event" required :disabled="f.event_type!=106">
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col">
                        <label class="label-input">Business name</label>
                        <input type="text" v-model="f.business_name" class="form-control" placeholder="Organization name">
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col">
                        <label class="label-input">Contact name </label>
                        <input type="text" v-model="f.contact_name" class="form-control" placeholder="Alex">
                    </div>
                    <div class="col">
                        <label class="label-input">Last name</label>
                        <input type="text" v-model="f.lastname" class="form-control" placeholder="Smith">
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col">
                        <label class="label-input">Phone *</label>
                        <input type="text" v-model="f.phone" class="form-control" placeholder="755-555-5555">
                    </div>
                    <div class="col">
                        <label class="label-input">Email</label>
                        <input type="text" v-model="f.email" class="form-control" placeholder="name@server.com">
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col">
                        <label class="label-input">Address</label>
                        <input type="text" v-model="f.address" class="form-control" placeholder="1234 Main St">
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col">
                        <label class="label-input">City</label>
                        <input type="text" v-model="f.city" class="form-control" placeholder="Milford">
                    </div>
                    <div class="col">
                        <label class="label-input">State</label>
                        <input type="text" v-model="f.state" class="form-control" placeholder="Ma">
                    </div>
                    <div class="col">
                        <label class="label-input">Zip code</label>
                        <input type="text" v-model="f.zip" class="form-control" placeholder="01547">
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col">
                        <label class="label-input">Description</label>
                        <textarea v-model="f.description" class="form-control" placeholder="Event description"
                            style="height: 100px;"></textarea>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col">
                        <button type="submit" class="btn btn-success btn-lg" style="margin-right: 20px;">Save</button>
                        <button type="button" class="btn btn-secondary btn-lg" @click="cancelModal">Cancel</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import '@/apps/Marketea/components/leads/calendar.scss';
import { duration } from 'vue-moment';
export default {
    name: 'formEvents',
    components: {
        DatePicker,
    },
    data() {
        return {
            isLoading: false,
            f: {
                // @ts-ignore
                user_id: window.master_client,
                // @ts-ignore
                org_id: window.localorgdata,
                event_id: null,
                event_name: '',
                org_name: '',
                business_name: '',
                contact_name: '',
                lastname: '',
                phone: '',
                email: '',
                address: '',
                state: '',
                city: '',
                zip: '',
                description: '',
                event_type_custom: '',
                event_date: null,
                event_type: 101,
            },
            updateData: false,
            showTimePanel: false,
            openCal: false,
            dateSelected: new Date(),
            listEventTypes: [],
        }
    },
    created() {
        let t = this;
        t.getEventTypes();
        // t.futureDate(7);
        let d = t.$store.getters['core/getOpenModal'].data;
        console.log('dataModal', d)
        if (d.id) {
            t.updateData = true;
            t.LoaderEventData(d);
        }else {
            t.futureDate(7);
        }
    },
    methods: {
        futureDate(moreDays = 1){
            let t = this;
            let today = new Date();
            const addDays = today;
            addDays.setDate(today.getDate() + moreDays);
            addDays.setHours(20, 0, 0, 0);
            // console.log('moreDays', addDays);
            t.dateSelected = addDays;
        },
        LoaderEventData(i) {
            console.log('LoaderEventData', i)
            let t = this;
            t.f.user_id =this.user_id;
            t.f.org_id = this.org_id;
            t.f.event_id = i.id;
            t.dateSelected = new Date(i.event_date);
            t.f.event_name= i.event_name || '';
            t.f.org_name= i.org_name || '';
            t.f.business_name= i.business_name || '';
            t.f.contact_name= i.contact_name || '';
            t.f.lastname= i.lastname || '';
            t.f.phone= i.phone || '';
            t.f.email= i.email || '';
            t.f.address= i.address || '';
            t.f.state= i.state || '';
            t.f.city= i.city || '';
            t.f.zip= i.zip || '';
            t.f.description= i.description || '';
            t.f.event_type_custom= i.event_type_custom || '';
            t.f.event_date= i.event_date || '';
            t.f.event_type= i.event_type || '';
            console.log('LoaderEventData', t.f);
        },
        getEventTypes() {
            let t = this;
            t.$store.commit("core/setLoadingModal", true);
            let url = "bRem/getEventTypes";
            // @ts-ignore
            window.master.post(url, {
                user_id: this.user_id,
                org_id: this.org_id
            })
            .then((response) => {
                // console.log('getEventTypes', response.data);
                t.listEventTypes = response.data;
                t.$store.commit("core/setLoadingModal", false);
            })
            .catch((error) => {
                console.log(error);
                t.$store.commit("core/setLoadingModal", false);
            });
        },
        saveEvent() {
            let t = this;
            let url = "bRem/createEvent";
            if(t.updateData){url= "bRem/updateEvent";}
            t.$store.commit("core/setLoadingModal", true);
            // @ts-ignore
            window.master.post(url, t.f)
                .then((response) => {
                    console.log('r', response.data);
                    t.$store.commit("core/setLoadingModal", false);
                    if(!response.data.success){
                        let error = response.data.errors ?? [];
                        if(error.length>0){
                            t.$store.commit("core/setNotiPush", {
                                show: true,
                                group: "notiPush",
                                type: '5', // 1=success|2=info|3=error|4=loading|5=warning
                                title: 'Failed!',
                                text: error[0],
                                duration: 5000
                            });
                        }
                        else if(response.data.message && response.data.message.length>0){
                            t.$store.commit("core/setNotiPush", {
                                show: true,
                                group: "notiPush",
                                type: '5', // 1=success|2=info|3=error|4=loading|5=warning
                                title: 'Failed!',
                                text: response.data.message,
                                duration: 5000
                            });
                        }
                    }else{
                        t.cancelModal(1);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    t.$store.commit("core/setLoadingModal", false);
                    t.$store.commit("core/setNotiPush", {
                        show: true,
                        group: "notiPush",
                        type: '3', // 1=success|2=info|3=error|4=loading|5=warning
                        title: 'Error!',
                        text: error.message ? error.message : 'Please try again later.',
                        duration: 5000
                    });
                });
        },
        cancelModal(val) {
            if(val) {
                let pushRefresh = this.$store.getters["ModApps/bRem/get_refresh_list"] + 1;
                this.$store.commit("ModApps/bRem/set_refresh_list", pushRefresh);
            }
            this.$parent.$emit('closed-lateral');
        },
        dateOpen() {
            this.openCal = true;
        },
        toggleTimePanel() {
            this.showTimePanel = !this.showTimePanel;
        },
        changeDate() {
            this.showTimePanel = true;
            if(!this.dateSelected) {
                this.futureDate(7);
            }
            this.f.event_date = this.setFormatDate(this.dateSelected)
            console.log('changeDate', this.f.event_date)
        },
        setFormatDate(isoDate){
            const date = new Date(isoDate);
            const formatted = date.getFullYear() + "-" +
            String(date.getMonth() + 1).padStart(2, "0") + "-" +
            String(date.getDate()).padStart(2, "0") + " " +
            String(date.getHours()).padStart(2, "0") + ":" +
            String(date.getMinutes()).padStart(2, "0") + ":" +
            String(date.getSeconds()).padStart(2, "0");
            console.log(formatted);
            return formatted;
        },
        handleOpenChange() {
            this.showTimePanel = false;
        },
        closeDatePicker() {
            this.showTimePanel = false;
            this.openCal = false;
        },
    }
}
</script>
<style lang="css" scoped>
.label-input{
    position: absolute;
    top: -0.6rem;
    left: 0.60rem;
    font-size: 0.9rem;
    line-height:1.5;
    color: #6c757d;
    background: white;
    padding: 0 0.35rem;
    z-index: 1;
    transition: all 0.2s;
    border-radius: 0.25rem;
}
.label-input + .form-control{
    padding-top: 0.8rem;
    padding-left: 1.5rem;
}
select.form-control:not([size]):not([multiple]){
    height: 45px;
}
</style>
